import { render, staticRenderFns } from "./flight-pad-endpoint.vue?vue&type=template&id=4af58e84&scoped=true"
import script from "./flight-pad-endpoint.vue?vue&type=script&lang=js"
export * from "./flight-pad-endpoint.vue?vue&type=script&lang=js"
import style0 from "./flight-pad-endpoint.vue?vue&type=style&index=0&id=4af58e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af58e84",
  null
  
)

export default component.exports